import { jsx as _jsx } from "react/jsx-runtime";
export function None(props) { return /*#__PURE__*/ _jsx("a", { style: { fontSize: "0.8rem", textDecoration: "underline", cursor: "pointer" }, onClick: () => props.onClick(), children: /*#__PURE__*/ _jsx("i", { children: props.children }) }); }
